import React, { Component } from "react";
import { Table, Pagination, Col, Row, Input, Select, Button } from "antd";
import moment from "moment";
import { strings } from "../../helpers";
import { Link } from "react-router-dom";
const { Search } = Input;
const { Option } = Select;

export default class UsersListView extends Component {
  render() {
    const {
      usersList,
      allRecords,
      pageNo,
      onPageChange,
      searchText,
      handleSearchText,
      handleSearch,
      filterBy,
      handleFilterBy,
      navigateToUsersDetails,
      featureFlags,
      activateModule,
      selectedUserId,
      handleUpdateClinicModule,
      handleUpdateUserFlag
    } = this.props;

    const columns = [
      {
        title: "phone number",
        key: "phone_number",
        align: "left",
        render: record => (
          <Link to={`users-details/${record.id}`}>
            {" "}
            {record.phone_number || "--"}
          </Link>
        )
      },
      {
        title: "Verified At",
        key: "verified_at",
        align: "left",
        render: record => (
          <div>
            {moment(record.verified_at).format("DD-MM-YYYY") +
              " " +
              moment(record.verified_at).format("LT") || "--"}
          </div>
        )
      },
      {
        title: "Email",
        width: 100,
        key: "email",
        align: "left",
        render: record => <div>{record.email || "--"}</div>
      },
      {
        title: "Account",
        key: "account",
        align: "left",
        render: record => <div>{record.account || "--"}</div>
      },
      {
        title: "Activated module",
        align: "left",
        render: record => (
          <div>
            <div>{record.packages_enabled ? "Care packages" : ""}</div>
            <div>{record.growth_enabled ? "Growth" : ""}</div>
          </div>
        )
      },
      {
        title: "Select Module",
        align: "left",
        width: 200,
        render: record => (
          <div className="d-flex vertical-align-center">
            <Select
              style={{ width: 120 }}
              onChange={(val, obj, recordId) =>
                handleUpdateClinicModule(val, obj, record)
              }
              placeholder="Select"
            >
              {featureFlags.length > 0 &&
                featureFlags.map(obj => {
                  return (
                    <Option key={obj?.id} value={obj?.id} specObj={obj}>
                      {obj?.name}
                    </Option>
                  );
                })}
            </Select>
            <Button
              type="primary"
              onClick={() => handleUpdateUserFlag(record)}
              className="ml-5"
            >
              {activateModule &&
              activateModule != undefined &&
              selectedUserId === record.id
                ? "Deactivate"
                : "Activate"}{" "}
            </Button>
          </div>
        )
      },
      {
        title: "Platform",
        key: "platform",
        align: "left",
        render: record => <div>{record.platform || "--"}</div>
      },
      {
        title: "Status",
        key: "status",
        align: "left",
        render: record => <div>{record.status || "--"}</div>
      }
    ];
    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              {strings.dashboard.users}
            </Col>
            <Col span={19}>
              <Row type="flex" align="middle" gutter={50}>
                <Col span={12}>
                  <label>{strings.dashboard.searchBy}</label>
                  <Search
                    className="mt-7"
                    value={searchText}
                    onChange={handleSearchText}
                    placeholder={strings.dashboard.searchByPhoneNumber}
                    onSearch={handleSearch}
                    onPressEnter={handleSearch}
                    allowClear
                  />
                </Col>
                <Col>
                  <div>
                    <label>{strings.dashboard.filterBy}</label>
                  </div>
                  <div>
                    <Select
                      defaultValue="all"
                      value={filterBy}
                      className="mt-7 filter-wrap-width"
                      placeholder={strings.dashboard.searchByStatePlaceholder}
                      onChange={handleFilterBy}
                    >
                      <Option value={null}>All</Option>
                      <Option value={"ACTIVE"}>Active</Option>
                    </Select>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              // onRowClick={record => navigateToUsersDetails(record.id)}
              columns={columns}
              dataSource={usersList}
              pagination={false}
              rowKey="id"
            />
          </div>
        </div>
        <div className="pagination-wrapper">
          {allRecords > 10 && (
            <div className="total-results-wrap">
              <span className="result-count">{allRecords}</span>
              {allRecords > 1 ? strings.results : strings.result}
            </div>
          )}
          {allRecords > 10 && (
            <Pagination
              total={allRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={10}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
